<template>
  <div>
    <v-row class="py-0">
      <v-col cols="3">
        <v-card max-width="300">
          <v-list shaped>
            <v-subheader class="font-italic text-subtitle-1">
              Pending Tags</v-subheader>
            <v-divider></v-divider>
            <v-list-item-group color="dw_green">
              <v-list-item v-if="pendingTags.length === 0" disabled>
                <v-list-item-content>
                  <v-list-item-title>No tags to review</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                v-else
                v-for="(tag, i) in pendingTags"
                :key="i"
                @click="reviewTag(tag)"
                two-line
                dense>
                <v-list-item-content>
                  <v-list-item-title class="font-weight-regular">
                    {{ tag.pending_state.name }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="caption grey--text">
                    {{ pendingState(tag.action) }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-col>
      <v-col v-if="selectedTag" cols="8">
        <v-form ref="reviewTagForm" v-model="formValid" @submit.prevent>
          <v-card flat v-if="selectedTag.action === 'UPD' && originalTag" class="mb-3" outlined>
            <v-card-title class="py-2 text-h6 font-weight-light">Original Tag</v-card-title>
            <v-divider></v-divider>
            <v-card-text class="py-2 px-8">
              <p class="mb-0">Name</p>
              <p class="mb-0 white--text">{{ originalTag.name }}</p>
            </v-card-text>
          </v-card>
          <v-card flat outlined>
            <v-card-title class="py-2 text-h6 font-weight-light">
              Suggested Tag
              <v-spacer></v-spacer>
              <span class="text-body-2">{{ selectedTag.submitted_by }}</span>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="px-4 py-0">
              <moderate-text-field
                ref="modField"
                :existing="selectedTag.pending_state.name"
                label="Edit Tag Name *"
                @saveChanges="editTag" />
            </v-card-text>
          </v-card>
          <v-row class="mt-12" no-gutters>
            <v-spacer></v-spacer>
            <v-btn
              type="button"
              :disabled="$refs.modField && $refs.modField.editField"
              @click="approveTag"
              color="primary"
              small
              text>
              Approve
              <v-icon small color="primary" class="ml-2" v-text="mdiCheckOutline" />
            </v-btn>
          </v-row>
        </v-form>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mdiCheckOutline, mdiPencilOutline, mdiCloseOutline } from '@mdi/js';
import { mapActions, mapGetters } from 'vuex';
import moderateTextField from '@/components/forms/reviewModerations/moderateTextField.vue';
import utils from '@/utils';

export default {
  name: 'reviewTags',
  components: {
    moderateTextField
  },
  data: () => ({
    mdiCheckOutline,
    mdiPencilOutline,
    mdiCloseOutline,
    selectedTag: undefined,
    formValid: false,
    originalTag: undefined
  }),
  computed: {
    ...mapGetters([
      'pendingTags'
    ])
  },
  methods: {
    pendingState: utils.pendingState,
    ...mapActions([
      'moderateTag',
      'fetchPending',
      'fetchOriginalByID',
      'fetchFilterOptions'
    ]),
    async approveTag() {
      try {
        await this.moderateTag({
          ...this.selectedTag,
          approved: true
        });
        this.selectedTag = undefined;
        this.fetchPending();
        this.fetchFilterOptions();
      } catch (err) {
        console.error(err);
      }
    },
    async reviewTag(tag) {
      this.selectedTag = tag;
      if (this.selectedTag.action === 'UPD') {
        this.originalTag = await this.fetchOriginalByID(['tag', this.selectedTag.target]);
      }
    },
    async editTag(newVal) {
      const changed = {
        ...this.selectedTag,
        pending_state: {
          name: newVal
        }
      };
      try {
        await this.moderateTag(changed);
        this.fetchPending();
        this.selectedTag = changed;
      } catch (err) {
        console.error(err);
      }
    }
  }
};
</script>
